// extracted by mini-css-extract-plugin
module.exports = {"spoilerDetails":"spoilerDetails-1U0a3","ticketExample":"ticketExample-Y2ZC-","close":"close-1l6w7"};